const header = require('@/commons/header/header');


// TODO: remove this file when all the legacies files will be deleted.
const headerMyAccount = {
  init: () => cube.event.on('reload-header-my-account', () => {
    header.init();
  })
};

module.exports = headerMyAccount;



// WEBPACK FOOTER //
// ./src/modules-es5/commons/layout/header-my-account.js